<template lang="pug">
  .page
    section
      .max-width
        OnboardingTutorial

</template>

<script>

import { mapState } from 'vuex'

import OnboardingTutorial from '@/components/OnboardingTutorial'

export default {
  name: 'Onboarding',
  components: {
    OnboardingTutorial
  },
  beforeMount () {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
</style>
